import React from "react";
import { Button } from "react-bootstrap";
import AxiosInstance from "../AxiosInstance";
const EmployeeRemarksTable = ({ remarks, handleDelete, handleEdit }) => {
  const capitalizeFirstLetter = (str) => {
    if (!str) return str; // If the description is empty, return it as is.
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  
  return (
    <div className="table-responsive">
      <table className="table table-hover text-center align-middle table-striped">
        <thead className="table-primary">
        <tr>
          <th scope="col">#</th>
          <th scope="col" className="text-start">Type</th>
          <th scope="col" className="text-start">Description</th>
          <th scope="col"className="text-start">Date</th>
          <th scope="col">Attachment</th>
          <th scope="col">Actions</th>
        </tr>
        </thead>
        <tbody>
          {remarks.map((remark, index) => (
            <tr key={remark.id}>
              <td>{index + 1}</td>
              <td className="text-start text-truncate" style={{ maxWidth: "200px" }}>
                {remark.remark_topic || <span className="text-muted">N/A</span>}
              </td>
              <td className="text-start text-truncate" style={{ maxWidth: "300px" }}>
                {remark.description
                  ? remark.description.length > 100
                    ? capitalizeFirstLetter(remark.description.slice(0, 100)) + "..."
                    : capitalizeFirstLetter(remark.description)
                  : <span className="text-muted">No Description</span>}
              </td>
              <td className="text-start text-truncate" style={{ maxWidth: "150px" }}>
                {remark.date
                  ? new Date(remark.date).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                  : <span className="text-muted">N/A</span>}
              </td>

              <td>
                {remark.file_path ? (
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => window.open(`${AxiosInstance.defaults.baseURL}/${remark.file_path}`, "_blank")}
                  >
                    <i className="bi bi-eye"></i>
                  </Button>
                ) : (
                  <span className="text-muted">N/A</span>
                )}
              </td>
              <td className="d-flex flex-wrap justify-content-center gap-2">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => handleEdit(remark.id)}
                >
                  <i className="bi bi-pencil"></i>
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(remark.id)}
                >
                  <i className="bi bi-trash"></i>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  
  );
};

export default EmployeeRemarksTable;
